import React,{Fragment} from 'react';
import Backimg from '../about/backimg';
import AllProjects from '../projects/allprojects';


const Projects = () => {
    return (
        <Fragment>
                <Backimg />
                <AllProjects />
        </Fragment>
    )
}

export default Projects;
